import {
  Component,
  OnInit,
  ChangeDetectorRef,
  TemplateRef,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../../master/services/master-service";
import { BsModalService } from "ngx-bootstrap/modal";
import { CommonHelper } from "../../../helper/helper.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { GrievanceDetailsService } from "../../../shared/grievance-details-popup/grievance-details.service";
import { GrievanceViewService } from "../../../shared/grievance-time-line-details/grievance-time-line-details.service";
import * as Chart from "chart.js";
import { config } from "rxjs";
const rxjsConfig = {
  Promise: Promise,
  useDeprecatedSynchronousErrorHandling: true,
};

@Component({
  selector: "app-helpdesk-dashboard",
  templateUrl: "./helpdesk-dashboard.component.html",
  styleUrls: ["./helpdesk-dashboard.component.scss"],
  providers: [MasterService, CommonHelper],
})
export class HelpdeskDashboardComponent implements OnInit {
  dataTable: any;
  allGreviancesData: number;
  pendingGreviancesData: number;
  closedGrevianceData: number;
  isAllGrievanceDataExists: boolean;
  isPendingExists: boolean;
  isClosedDataExists: boolean;
  registerGrievancesData: any;
  allPGriCount: any;
  allCGriCount: any;
  allRGriCount: any;
  allCountExist: boolean = false;
  grieveanceDetailsData: any;
  grievanceHistoryData: any;
  modalRef: BsModalRef;
  userFeedBackForm: FormGroup;
  gId: Number;
  errorCheck: boolean = false;
  modalBool: boolean = false;
  modalView: boolean = false;
  districtData: any;
  stateData: any;
  actionTakenData: Array<any> = [];
  fileUploadData: Array<any> = [];
  stateId: any;
  roleId: any;
  chartData: any;
  dailySeverityData: any;
  pendingFormsData: any;
  districtId: any = "";
  kpiData: any;
  showState: boolean = false;
  showdistrict: boolean = false;
  state_Id: any = "";
  state_id: any;
  myChart: any;

  constructor(
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private route: Router,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private commonHelper: CommonHelper,
    private grievanceDetailsPopupModal: GrievanceDetailsService,
    private grievanceViewService: GrievanceViewService
  ) { }

  ngOnInit(): void {
    this.getLocalData();
    this.getDailySeverityData("");
    this.getPendingFormsData("");

    this.chart("");
    this.getKpiValues(this.districtId);
    if (this.roleId == 1) {
      this.getStates();
    }
    if (this.roleId == 5) {
      this.getStates();
    }
    this.changeState(this.stateId);
  }
  public getLocalData(): void {
    this.roleId = Number(localStorage.getItem("roleId"));
    this.stateId = localStorage.getItem("stateId");
  }

  // Define a function that generates colors based on the xValues
  generateColors(labels) {
    var colors = [];
    for (var i = 0; i < labels.length; i++) {
      // Generate a color based on the length of the label
      var length = labels[i].length;
      var hue = length * 30;
      var color = "hsl(" + hue + ", 50%, 50%)";
      colors.push(color);
    }
    return colors;
  }

  /**
   * getChartData
   */
  public getDailySeverityData(id): void {
    if (this.roleId == 1) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/daily/severity?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              this.dailySeverityData = response;
              this.spinner.hide();
            } else {
              this.dailySeverityData = [];
              this.spinner.hide();
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    } else if (this.roleId == 3) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/daily/severity?district_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              this.dailySeverityData = response;
              this.spinner.hide();
            } else {
              this.dailySeverityData = [];
              this.spinner.hide();
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    } else if (this.roleId == 5) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/daily/severity?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              this.dailySeverityData = response;
              this.spinner.hide();
            } else {
              this.dailySeverityData = [];
              this.spinner.hide();
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    }
  }

  /**
   * getPendingFormsData
   */
  public getPendingFormsData(id): void {
    if (this.roleId == 1) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/pending-form/grievance?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status === 200) {
              this.pendingFormsData = response["data"];
              this.spinner.hide();
            } else {
              this.spinner.hide();
              this.pendingFormsData = [];
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    } else if (this.roleId == 3) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/pending-form/grievance?district_id=${id}`)
          .subscribe((response: any) => {
            if (response.status === 200) {
              this.pendingFormsData = response["data"];
              this.spinner.hide();
            } else {
              this.spinner.hide();
              this.pendingFormsData = [];
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    } else if (this.roleId == 5) {
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/pending-form/grievance?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status === 200) {
              this.pendingFormsData = response["data"];
              this.spinner.hide();
            } else {
              this.spinner.hide();
              this.pendingFormsData = [];
            }
          });
      } catch (excp) {
        this.spinner.hide();
      }
    }
  }

  chart(id) {
    if (this.roleId == 1) {
      const xValues: any[] = [];
      const yValues: any[] = [];
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/graph?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              if (response["data"] && response["data"].length > 0) {
                this.chartData = response["data"];
                for (let i = 0; i < this.chartData.length; i++) {
                  const element = this.chartData[i];
                  xValues.push(element.name);
                  yValues.push(element.total_grievance);
                }
                const barColors = this.generateColors(xValues);
                const canvas = document.getElementById(
                  "myChart"
                ) as HTMLCanvasElement;

                this.myChart = new Chart(canvas, {
                  type: "bar",
                  data: {
                    labels: xValues,
                    datasets: [
                      {
                        backgroundColor: barColors,
                        data: yValues,
                        label: "State Complaints",
                      },
                    ],
                  },
                  options: {
                    aspectRatio: 1.8,
                    responsive: true,
                    animation: {}, // Disable chart animation
                    scales: {
                      yAxes: [
                        {
                          scaleLabel: {
                            display: true,
                            labelString: "Number of Complaints",
                          },
                          ticks: {
                            callback: function (val: number) {
                              return Number.isInteger(val) ? val : null;
                            },
                            min: 0, // set the minimum value
                          },
                        },
                      ],
                      xAxes: [
                        {
                          ticks: {
                            maxTicksLimit: 75,
                          },

                          scaleLabel: {
                            display: true,
                            labelString: "States",
                          },
                        },
                      ],
                    },
                    maintainAspectRatio: false,

                    title: {
                      display: true,
                      text: "State Wise Total Complaints",
                    },

                    legend: {
                      onClick: function (event, legendItem) {
                        const chart = this.chart;
                        const index = this.chart.data.labels.indexOf(
                          legendItem.text
                        );
                        const meta = this.chart.getDatasetMeta(0).data[index];
                        meta.hidden = !meta.hidden;

                        this.chart.update(); // update the chart after changing the data visibility
                      },

                      labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        // Generate legend labels with colored squares
                        generateLabels: (chart: any) => {
                          const hidden = chart
                            .getDatasetMeta(0)
                            .data.map((data) => data.hidden);
                          return chart.data.labels.map(
                            (label: any, index: any) => ({
                              boxHeight: 5,
                              text: label,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[index],
                              hidden: hidden[index],
                            })
                          );
                        },
                      },
                    },
                  },
                });
              } else {
                this.chartData = [];
              }
            } else {
              this.spinner.hide();
              this.chartData = [];
            }
          });
      } catch (err) {
        this.spinner.hide();
      }
    } else if (this.roleId == 3) {
      const xValues: any[] = [];
      const yValues: any[] = [];
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/graph?district_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              if (response["data"] && response["data"].length > 0) {
                this.chartData = response["data"];
                for (let i = 0; i < this.chartData.length; i++) {
                  const element = this.chartData[i];
                  xValues.push(element.name);
                  yValues.push(element.total_grievance);
                }
                const barColors = this.generateColors(xValues);
                const canvas = document.getElementById(
                  "myChart"
                ) as HTMLCanvasElement;

                this.myChart = new Chart(canvas, {
                  type: "bar",
                  data: {
                    labels: xValues,
                    datasets: [
                      {
                        backgroundColor: barColors,
                        data: yValues,
                        label: "Districts Complaints",
                      },
                    ],
                  },
                  options: {
                    aspectRatio: 1.8,
                    scales: {
                      yAxes: [
                        {
                          scaleLabel: {
                            display: true,
                            labelString: "Number of Complaints",
                          },
                          ticks: {
                            callback: function (val: number) {
                              return Number.isInteger(val) ? val : null;
                            },
                            min: 0, // set the minimum value
                          },
                        },
                      ],
                      xAxes: [
                        {
                          ticks: {
                            maxTicksLimit: 75,
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "Districts",
                          },
                        },
                      ],
                    },
                    maintainAspectRatio: false,
                    title: {
                      display: true,
                      text: "District Wise Total Complaints",
                    },
                    legend: {
                      onClick: function (event, legendItem) {
                        const chart = this.chart;
                        const index = this.chart.data.labels.indexOf(
                          legendItem.text
                        );
                        const meta = this.chart.getDatasetMeta(0).data[index];
                        meta.hidden = !meta.hidden;

                        this.chart.update(); // update the chart after changing the data visibility
                      },

                      labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        // Generate legend labels with colored squares
                        generateLabels: (chart: any) => {
                          const hidden = chart
                            .getDatasetMeta(0)
                            .data.map((data) => data.hidden);
                          return chart.data.labels.map(
                            (label: any, index: any) => ({
                              boxHeight: 5,
                              text: label,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[index],
                              hidden: hidden[index],
                            })
                          );
                        },
                      },
                    },
                  },
                });
              } else {
                this.chartData = [];
              }
            } else {
              this.spinner.hide();
              this.chartData = [];
            }
          });
      } catch (err) {
        this.spinner.hide();
      }
    } else if (this.roleId == 5) {
      const xValues: any[] = [];
      const yValues: any[] = [];
      try {
        this.spinner.show();
        this.masterService
          .getAll(`state-wise/graph?state_id=${id}`)
          .subscribe((response: any) => {
            if (response.status == 200) {
              if (response["data"] && response["data"].length > 0) {
                this.chartData = response["data"];
                for (let i = 0; i < this.chartData.length; i++) {
                  const element = this.chartData[i];
                  xValues.push(element.name);
                  yValues.push(element.total_grievance);
                }
                const barColors = this.generateColors(xValues);
                const canvas = document.getElementById(
                  "myChart"
                ) as HTMLCanvasElement;

                this.myChart = new Chart(canvas, {
                  type: "bar",
                  data: {
                    labels: xValues,
                    datasets: [
                      {
                        backgroundColor: barColors,
                        data: yValues,
                        label: "State Complaints",
                      },
                    ],
                  },
                  options: {
                    aspectRatio: 1.8,
                    responsive: true,
                    animation: {}, // Disable chart animation
                    scales: {
                      yAxes: [
                        {
                          scaleLabel: {
                            display: true,
                            labelString: "Number of Complaints",
                          },
                          ticks: {
                            callback: function (val: number) {
                              return Number.isInteger(val) ? val : null;
                            },
                            min: 0, // set the minimum value
                          },
                        },
                      ],
                      xAxes: [
                        {
                          ticks: {
                            maxTicksLimit: 75,
                          },

                          scaleLabel: {
                            display: true,
                            labelString: "States",
                          },
                        },
                      ],
                    },
                    maintainAspectRatio: false,

                    title: {
                      display: true,
                      text: "State Wise Total Complaints",
                    },

                    legend: {
                      onClick: function (event, legendItem) {
                        const chart = this.chart;
                        const index = this.chart.data.labels.indexOf(
                          legendItem.text
                        );
                        const meta = this.chart.getDatasetMeta(0).data[index];
                        meta.hidden = !meta.hidden;

                        this.chart.update(); // update the chart after changing the data visibility
                      },

                      labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        // Generate legend labels with colored squares
                        generateLabels: (chart: any) => {
                          const hidden = chart
                            .getDatasetMeta(0)
                            .data.map((data) => data.hidden);
                          return chart.data.labels.map(
                            (label: any, index: any) => ({
                              boxHeight: 5,
                              text: label,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[index],
                              hidden: hidden[index],
                            })
                          );
                        },
                      },
                    },
                  },
                });
              } else {
                this.chartData = [];
              }
            } else {
              this.spinner.hide();
              this.chartData = [];
            }
          });
      } catch (err) {
        this.spinner.hide();
      }
    }
  }

  changeState(stateId: number) {
    this.masterService
      .getData("active_districts" + "/", stateId)
      .subscribe((response: any) => {
        if (response.status == 200) {
          response.data[0].districts.unshift({
            description: "",
            grievanceTypeId: "",
            districtId: "",
            name: "All",
            status: "active",
          });
          this.districtData = response.data[0].districts;
        }
      });
  }
  districtChange(event) {
    this.districtId = event.districtId;
  }
  stateChange(event) {
    this.stateId = event.id;
  }
  onSubmit() {
    if (this.roleId == 1) {
      this.getKpiValues(this.stateId);
      this.getDailySeverityData(this.stateId);
      this.getPendingFormsData(this.stateId);
      this.noChartData(this.stateId, "state_id");
    } else if (this.roleId == 3) {
      this.getKpiValues(this.districtId);
      this.getDailySeverityData(this.districtId);
      this.getPendingFormsData(this.districtId);
      this.noChartData(this.districtId, "district_id");
    } else if (this.roleId == 5) {
      this.getKpiValues(this.stateId);
      this.getDailySeverityData(this.stateId);
      this.getPendingFormsData(this.stateId);
      this.noChartData(this.stateId, "state_id");
    }
  }

  getKpiValues(id) {
    if (this.roleId == 1) {
      this.showState = true;
      this.masterService
        .getAll("state-wise/total_grievance" + "?state_id=" + id)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.kpiData = response["data"][0];
          }
        });
    } else if (this.roleId == 3) {
      this.showdistrict = true;
      this.masterService
        .getAll("state-wise/total_grievance" + "?district_id=" + id)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.kpiData = response["data"][0];
          }
        });
    } else if (this.roleId == 5) {
      this.showState = true;
      this.masterService
        .getAll("state-wise/total_grievance" + "?state_id=" + id)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.kpiData = response["data"][0];
          }
        });
    }
  }

  getStates() {
    this.masterService.getAll("active_states").subscribe((response: any) => {
      if (response.status == 200) {
        response.data.unshift({
          description: "",
          grievanceTypeId: "",
          name: "All",
          id: "",
          status: "active",
        });

        this.stateData = response.data;
      } else {
        this.stateData = [];
      }
    });
  }

  /**API calling method
   *
   * @param url
   * @param greviancesType
   */
  getAllGrievanceCount(apiRoute: string) {
    try {
      this.masterService.getHelpDeskCount(apiRoute).subscribe(
        (response: any) => {
          if (response.status) {
            if (response.data.length > 0) {
              this.spinner.hide();
              this.allCountExist = true;
              this.allPGriCount = response.data[0].totalPending;
              this.allCGriCount = response.data[0].totalClosed;
              this.allRGriCount = response.data[0].totalRegistered;
              this.allPGriCount;
            } else {
              this.spinner.hide();
              this.allCountExist = false;
              this.allPGriCount = 0;
              this.allCGriCount = 0;
              this.allRGriCount = 0;
            }
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /*getData bind table data */
  getData(apiRoute: string) {
    this.spinner.show();
    try {
      this.spinner.show();
      this.masterService.getHelpDesk(apiRoute).subscribe(
        (response: any) => {
          if (response.status) {
            if (response.data.length > 0) {
              this.spinner.hide();
              this.registerGrievancesData = response.data;
              const table: any = $("table");
              this.reploatingDataTable();
              this.chRef.detectChanges();
              this.dataTable = table.DataTable({ order: [] }).draw();
            } else {
              this.spinner.hide();
              this.registerGrievancesData = [];
              this.reploatingDataTable();
              this.chRef.detectChanges();
              const table: any = $("table");
              this.dataTable = table.DataTable().draw();
            }
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }

  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable1").DataTable();
    table.destroy();
  }
  /*routing grievance history screen */
  viewTimeLineGrievance(id) {
    this.modalView = true;
    this.modalBool = false;
    this.masterService.getData("grievance_history/", id).subscribe(
      (response: any) => {
        if (response) {
          this.spinner.hide();
          this.grievanceHistoryData = response.data;
          // this.modalRef.hide()
          this.openViewModal();
        } else {
          this.spinner.hide();
          this.grievanceHistoryData = [];
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  /* Function for Opening the View Model*/
  openViewModal() {
    this.grievanceViewService.open();
  }

  /* Showing grievance Modal Popup on click of grievamce Id*/
  grievanceDetailsModal(grievanceId) {
    this.modalBool = true;
    this.masterService
      .getGrievanceDetails("grievance_details/", grievanceId)
      .subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.grieveanceDetailsData = response.data[0];
            this.getFiles(grievanceId);
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  /* Showing the User Grievance FeedBack Modal Popup*/
  grievanceUserFeedBackModal(template: TemplateRef<any>, grievanceId) {
    if (this.userFeedBackForm) {
      this.userFeedBackForm.reset();
    }
    this.userFeedBackForm = this.fb.group({
      feedbackComment: ["", Validators.maxLength(250)],
      feedbackStatus: [true, Validators.required],
    });
    this.gId = grievanceId;
    this.modalRef = this.modalService.show(template);
  }

  noChartData(id, value) {
    let xValues: any[] = [];
    let yValues: any[] = [];
    try {
      this.spinner.show();
      this.masterService
        .getAll(`state-wise/graph?${value}=${id}`)
        .subscribe((response: any) => {
          if (response.status == 200) {
            if (response["data"].length > 0) {
              this.chartData = [];

              this.chartData = response["data"];
              if (this.myChart) {
                this.myChart.destroy();
              }

              for (let i = 0; i < this.chartData.length; i++) {
                const element = this.chartData[i];
                xValues.push(this.chartData[i].name);
                yValues.push(this.chartData[i].total_grievance);
              }
              const barColors = this.generateColors(xValues);
              const canvas = document.getElementById(
                "myChart"
              ) as HTMLCanvasElement;

              if (this.roleId == 3) {
                this.myChart = new Chart(canvas, {
                  type: "bar",
                  data: {
                    labels: xValues,
                    datasets: [
                      {
                        backgroundColor: barColors,
                        data: yValues,
                        label: "State Complaints",
                      },
                    ],
                  },
                  options: {
                    aspectRatio: 1.8,
                    devicePixelRatio: 1, // Increase pixel density
                    scales: {
                      yAxes: [
                        {
                          scaleLabel: {
                            display: true,
                            labelString: "Number of Complaints",
                          },
                          ticks: {
                            callback: function (val: number) {
                              return Number.isInteger(val) ? val : null;
                            },
                            min: 0, // set the minimum value
                          },
                        },
                      ],
                      xAxes: [
                        {
                          ticks: {
                            maxTicksLimit: 75,
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "Districts",
                          },
                        },
                      ],
                    },
                    maintainAspectRatio: false,
                    title: {
                      display: true,
                      text: "District Wise Total Complaints",
                    },

                    legend: {
                      onClick: function (event, legendItem) {
                        const chart = this.chart;
                        const index = this.chart.data.labels.indexOf(
                          legendItem.text
                        );
                        const meta = this.chart.getDatasetMeta(0).data[index];
                        meta.hidden = !meta.hidden;

                        this.chart.update(); // update the chart after changing the data visibility
                      },

                      labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        // Generate legend labels with colored squares
                        generateLabels: (chart: any) => {
                          const hidden = chart
                            .getDatasetMeta(0)
                            .data.map((data) => data.hidden);
                          return chart.data.labels.map(
                            (label: any, index: any) => ({
                              boxHeight: 5,
                              text: label,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[index],
                              hidden: hidden[index],
                            })
                          );
                        },
                      },
                    },
                    plugins: {
                      noData: {
                        text: "No data available",
                        align: "center",
                        verticalAlign: "center",
                        font: {
                          size: 18,
                        },
                        color: "#0000",
                      },
                    },
                  },
                });
              } else {
                this.myChart = new Chart(canvas, {
                  type: "bar",
                  data: {
                    labels: xValues,
                    datasets: [
                      {
                        backgroundColor: barColors,
                        data: yValues,
                        label: "State Complaints",
                      },
                    ],
                  },
                  options: {
                    aspectRatio: 1.8,
                    devicePixelRatio: 1, // Increase pixel density
                    scales: {
                      yAxes: [
                        {
                          scaleLabel: {
                            display: true,
                            labelString: "Number of Complaints",
                          },
                          ticks: {
                            callback: function (val: number) {
                              return Number.isInteger(val) ? val : null;
                            },
                            min: 0, // set the minimum value
                          },
                        },
                      ],
                      xAxes: [
                        {
                          ticks: {
                            maxTicksLimit: 75,
                          },
                          scaleLabel: {
                            display: true,
                            labelString: "States",
                          },
                        },
                      ],
                    },

                    maintainAspectRatio: false,
                    title: {
                      display: true,
                      text: "State Wise Total Complaints",
                    },

                    legend: {
                      onClick: function (event, legendItem) {
                        const chart = this.chart;
                        const index = this.chart.data.labels.indexOf(
                          legendItem.text
                        );
                        const meta = this.chart.getDatasetMeta(0).data[index];
                        meta.hidden = !meta.hidden;
                        this.chart.update(); // update the chart after changing the data visibility
                      },

                      labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        // Generate legend labels with colored squares
                        generateLabels: (chart: any) => {
                          const hidden = chart
                            .getDatasetMeta(0)
                            .data.map((data) => data.hidden);
                          return chart.data.labels.map(
                            (label: any, index: any) => ({
                              boxHeight: 5,
                              text: label,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[index],
                              hidden: hidden[index],
                            })
                          );
                        },
                      },
                    },
                    plugins: {
                      noData: {
                        text: "No data available",
                        align: "center",
                        verticalAlign: "center",
                        font: {
                          size: 18,
                        },
                        color: "#0000",
                      },
                    },
                  },
                });
              }

              this.myChart.update();
            } else {
              this.chartData = [];

              this.chartData = response["data"];
              if (this.myChart) {
                this.myChart.destroy();
              }

              for (let i = 0; i < this.chartData.length; i++) {
                const element = this.chartData[i];
                xValues.push(this.chartData[i].name);
                yValues.push(this.chartData[i].total_grievance);
              }
              const barColors = this.generateColors(xValues);
              const canvas = document.getElementById(
                "myChart"
              ) as HTMLCanvasElement;

              this.myChart = new Chart(canvas, {
                type: "bar",
                data: {},
                options: {
                  scales: {
                    yAxes: [
                      {
                        scaleLabel: {
                          display: true,
                          labelString: "Number of Complaints",
                        },
                        ticks: {
                          callback: function (val: number) {
                            return Number.isInteger(val) ? val : null;
                          },
                        },
                      },
                    ],
                    xAxes: [
                      {
                        ticks: {
                          maxTicksLimit: 75,
                        },
                        scaleLabel: {
                          display: true,
                          labelString: "States",
                        },
                      },
                    ],
                  },
                  title: {
                    display: true,
                    text: "State Wise Total Complaints",
                  },

                  legend: {
                    onClick: function (event, legendItem) {
                      const chart = this.chart;
                      const index = this.chart.data.labels.indexOf(
                        legendItem.text
                      );
                      const meta = this.chart.getDatasetMeta(0).data[index];
                      meta.hidden = !meta.hidden;

                      this.chart.update(); // update the chart after changing the data visibility
                    },

                    labels: {
                      // Generate legend labels with colored squares
                      generateLabels: (chart: any) => {
                        const hidden = chart
                          .getDatasetMeta(0)
                          .data.map((data) => data.hidden);
                        return chart.data.labels.map(
                          (label: any, index: any) => ({
                            text: label,
                            fillStyle:
                              chart.data.datasets[0].backgroundColor[index],
                            hidden: hidden[index],
                          })
                        );
                      },
                    },
                  },
                  plugins: {
                    noData: {
                      text: "No data available",
                      align: "center",
                      verticalAlign: "center",
                      font: {
                        size: 18,
                      },
                      color: "#0000",
                    },
                  },
                },
              });

              this.myChart.update();
            }
          } else {
            this.spinner.hide();
            this.chartData = [];
          }
        });
    } catch (err) {
      this.spinner.hide();
    }
  }

  /*submit FeedBack*/
  submitUserFeedback() {
    try {
      let apiValues = this.userFeedBackForm.value,
        status = apiValues.feedbackStatus ? "satisfied" : "unsatisfied",
        data = {
          grievanceId: this.gId,
          feedback: status,
          comment: apiValues.feedbackComment,
        };
      this.modalRef.hide();
      this.masterService.postData("grievance_feedback", data).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.commonHelper.toasterMessage(response.message);
            this.getData("beneficiary/grievance_list_all");
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }

  //function to diaable or enable the subbmit button
  emptyDisable(event) {
    if (event.target.value.length <= 255) {
      this.errorCheck = false;
    } else if (event.target.value.length > 255) {
      this.errorCheck = true;
    }
  }

  /* Function for Opening the Password Popup Model*/
  openModal() {
    this.grievanceDetailsPopupModal.open();
  }

  /*getData bind table data */
  getFiles(id) {
    try {
      this.spinner.show();
      this.openModal();
      this.masterService.getAll("grievance_uploads/" + id).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.actionTakenData = response.data;
            this.actionTakenData.map((item) => {
              if (item.isGrievanceRedressed == 1) {
                item.isGrievanceRedressedVal = "Yes";
              } else {
                item.isGrievanceRedressedVal = "No";
              }
              this.fileUploadData = item.uploads;
            });
          } else {
            this.spinner.hide();
            this.actionTakenData = [];
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }
}
